import { useAppDispatch } from "store";
import styled from "@emotion/styled";
import { Button, Col } from "antd";
import { FC } from "react";
import { sigOut } from "store/slices/authSlice";
import { queryClient } from "../../../queryClient";

const MenuLogout: FC = ({}) => {
  const dispatch = useAppDispatch();

  return (
    <Col
      xs={{ span: 24 }}
      sm={{ span: 24 }}
      md={{ span: 24 }}
      xl={{ span: 24 }}
    >
      <CardWrapper>
        <Button
          onClick={() => {
            queryClient.clear();
            dispatch(sigOut());
          }}
          size="large"
          style={{ minWidth: 200, maxWidth: 350 }}
          danger
        >
          ออกจากระบบ
        </Button>
      </CardWrapper>
    </Col>
  );
};

export default MenuLogout;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 10px 30px 10px 30px;
  // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  &:hover {
    // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  }
  border-bottom: 1px solid #efefef;
`;
